import React from "react";
import { RouteComponentProps } from "react-router";
import { Box, Typography } from "@material-ui/core";

import {
  LoadingIndicator,
  B2BSpinner,
  HotelPriceBreakdown,
  IHotelPriceLineItem,
} from "halifax";
import { CallState } from "redmond";
import { PriceBreakdownConnectorProps } from "./container";

import * as constants from "./textConstants";
import "./styles.scss";

export interface IPriceBreakdownProps
  extends PriceBreakdownConnectorProps,
    RouteComponentProps {}

export const PriceBreakdown = ({
  pollPriceQuoteCallState,
  pricingLineItems,
  rewardsAndTotalLineItems,
  isPayLater,
}: IPriceBreakdownProps) => {
  const showLoadingIndicator =
    pollPriceQuoteCallState === CallState.InProcess ||
    pricingLineItems.length === 0;

  const pricingItems = pricingLineItems[0] as IHotelPriceLineItem[];

  return (
    <Box className="premier-collection-price-breakdown">
      {showLoadingIndicator ? (
        <LoadingIndicator
          indicatorSize="small"
          indicator={B2BSpinner}
          message="Fetching latest price"
        />
      ) : (
        <>
          <HotelPriceBreakdown
            className="pricing-line-items-breakdown"
            pricingItems={pricingItems}
            totalItems={pricingLineItems[1]}
            summaryItems={rewardsAndTotalLineItems}
          />

          {isPayLater && (
            <Typography className="pay-later-cancellation-no-show-notes">
              {constants.PAY_LATER_CANCELLATION_NO_SHOW_NOTES}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};
